import { FormEvent, useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { errorMessage } from '../api';
import { useAuth } from '../auth/AuthContext';
import { safeNext } from '../auth/RequireAuth';
import { Alert } from '../Components/ui';

export default function Login() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const next = safeNext(params.get('next'));
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    if (user) return <Navigate to={next} replace />;

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            await login(email, password);
            navigate(next, { replace: true });
        } catch (err) {
            setError(errorMessage(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <section className="section page-section narrow">
            <span className="section-label">Account</span>
            <h1 className="page-title">Log in</h1>
            <p className="section-desc">Manage your hosting, domains and orders.</p>

            <div className="form-card" data-aos="fade-up">
                {error && <Alert type="error">{error}</Alert>}
                <form className="fi-form" onSubmit={submit}>
                    <label>
                        Email
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" placeholder="your.email@example.com" />
                    </label>
                    <label>
                        Password
                        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
                    </label>
                    <button type="submit" className="btn-submit" disabled={busy}>{busy ? 'Logging in…' : 'Log in'}</button>
                </form>
                <div className="form-footer">
                    No account yet? <Link className="text-link" to={`/register?next=${encodeURIComponent(next)}`}>Sign up</Link>
                </div>
            </div>
        </section>
    );
}
